import { UseQueryOptions } from 'react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from 'hooks/useQuery';

const useContactUnsubscribes = (reactQueryOptions?: UseQueryOptions<any, Error>) => {
    const path = CuredApiPaths.REPORT_CONTACTS_UNSUBSCRIBES;

    return useQuery('contacts-unsubscribes', path, reactQueryOptions);
};

export default useContactUnsubscribes;
